import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import FetchingSelect from '@/components/FetchingSelect';
import { DiscoveryPointAchievementType, UpsertDiscoveryPointAchievementType } from '@/models/achievement.model';
import { getDiscoveryPointsLookup } from '@/services/discovery-point.service';

const modelSchema = Schema.Model<UpsertDiscoveryPointAchievementType>({
  discoveryPointId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertDiscoveryPointAchievementType = {
  discoveryPointId: undefined,
};

export interface DiscoveryPointAchievementInitValue {
  discoveryPointId?: number,
};

interface DiscoveryPointFormProps{
  formObject?: DiscoveryPointAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
  initValue?: DiscoveryPointAchievementInitValue;
}

const DiscoveryPointForm: React.FC<DiscoveryPointFormProps> = ({ formObject, onFormChange, formRef, loading, initValue }) => {
  const [formValue, setFormValue] = useState<UpsertDiscoveryPointAchievementType>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue({...emptyModel, discoveryPointId: initValue?.discoveryPointId});
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-discovery-point' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="discoveryPointId">
              <Form.Label>Discovery Point</Form.Label>
              <Form.Control name="discoveryPointId" accepter={FetchingSelect} block
                fetchData={(text, page) => getDiscoveryPointsLookup(text, page)} 
                placeholder="Select a discovery point"
                value={formValue.discoveryPointId}
                onChange={val=> setFormValue(pre => ({...pre, discoveryPointId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default DiscoveryPointForm;